<template>
  <div>
    <section class="hero hero-lp hero-summersale is-clipped has-background-primary">
      <div class="hero-body ">
        <div class="container is-relative">
          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1"
            v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-6-tablet is-6-desktop has-text-centered-mobile titlearea">
              <h1
                class="title has-background-secondary is-inline-block is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold has-text-white pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title summersale-title is-size-3 has-text-weight-bold has-text-black"><span
                  class="is-inline-block-tablet is-block-mobile">Sommer-Schluss-Verkauf </span> <span
                  class="is-inline-block summersale-subtitle is-size-5">vom 30.08. - 13.09.2021</span></h2>
              <!-- <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p> -->
            </div>
            <div class="column has-text-centered">
              <img fetchpriority="high"
                :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/ssv.png`"
                alt="SSV" width="781" height="326" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title is-size-5-mobile">Sommer-Schluss-Verkauf: ausgewählte Kurzurlaube nochmals um 15% reduziert
            </h2>
            <!-- <h3 class="subtitle has-text-weight-bold">subtitle</h3> -->
            <div class="content">
              <p>
                Sommer-Schluss-Verkauf auf ADAC Hotelgutschein: Vom 30.08.-13.09.2021 haben wir ausgewählte, bereits
                reduzierte Kurzurlaube für Sie <strong>nochmals um 15% reduziert.</strong> Schlagen Sie zu und sichern
                sich Ihren SSV-Deal, einen ADAC Hotelgutschein für einen Aufenthalt in einem
                exklusiven Hotel in Deutschland, Österreich, Südtirol/Italien. Für nochmal Sommer im Herbst oder Ihren
                nächsten Wander-, Ski- oder Strandurlaub. Ideal auch als Geschenk, da 3 Jahre gültig und übertragbar.
              </p>
              <p class="has-text-weight-bold">Nicht warten – kaufen!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div class="columns" v-if="offers.length == 0">
          <div class="column is-8 is-offset-2">
            <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold"
              role="status" aria-live="polite">
              <b-icon icon="sad-cry" size="is-large"></b-icon>
              <br />Leider sind keine Angebote vorhanden!
            </div>
          </div>
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:summersale -->

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--summersale" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'
export default {
  name: 'SummerSale',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
  },
  data() {
    return {
      offers: [],
    }
  },
  computed: {
    campaignTimer: function () {
      let endDate = new Date('2021-09-13 23:59') - new Date()
      return endDate
    },
  },
  async mounted() {
    this.offers = await OfferApi.getOffersWithCustomPromotion('ssv2021')
  },
  metaInfo() {
    return {
      title: 'Sommer-Schluss-Verkauf',
      meta: [{ name: 'description', content: 'Sommer-Schluss-Verkauf: ausgewählte Kurzurlaube nochmals um 15% reduziert!' }],
      link: [{ rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous' }],
    }
  },
}
</script>

<style lang="scss">
.hero-summersale {
  .hero-body {
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}

.summersale-title {
  line-height: 1;

  @media screen and (min-width: 1024px) {
    font-size: 2.6rem !important;
  }

  @media screen and (min-width: 1216px) {
    font-size: 3.1rem !important;
  }

  @media screen and (min-width: 1408px) {
    font-size: 3.7rem !important;
  }
}

.summersale-subtitle {
  line-height: 1;

  @media screen and (min-width: 1024px) {
    font-size: 1.6rem !important;
  }

  @media screen and (min-width: 1216px) {
    font-size: 2.5rem !important;
  }

  @media screen and (min-width: 1408px) {
    font-size: 3rem !important;
  }
}

.offer--summersale {
  .card-tag .tag {
    background-color: red !important;
  }
}
</style>
